class TemplateEmail{
    constructor() {
    }

    static get_form(){
        return{
            title : null,
            category : null,
            text : null,
            object : null,
        }
    }
}

module.exports.TemplateEmail = TemplateEmail ;